import { LoanType } from '../loans/LoanType';
import { PreferredTermType } from './PreferredTermType';

export const PreferredTermTypeOptions = [
    {
        id: PreferredTermType.FivePlusTwo,
        name: '7 Year (5+2)',
        shortName: '5+2',
        sortOrder: 1,
        active: true,
        loanTypes: [LoanType.Rental, LoanType.BuildRent],
    },
    {
        id: PreferredTermType.TenPlusTwo,
        name: '12 Year (10+2)',
        shortName: '10+2',
        sortOrder: 2,
        active: true,
        loanTypes: [LoanType.Rental, LoanType.BuildRent],
    },
    {
        id: PreferredTermType.FifteenPlusTwo,
        name: '17 Year (15+2)',
        shortName: '15+2',
        sortOrder: 3,
        active: false,
        loanTypes: [LoanType.Rental],
    },
    {
        id: PreferredTermType.SixPlusSix,
        name: '6 Months + 6 Months',
        shortName: '6+6',
        sortOrder: 1,
        active: true,
        loanTypes: [LoanType.Bridge],
    },
    {
        id: PreferredTermType.NinePlusSix,
        name: '9 Months + 6 Months',
        shortName: '9+6',
        sortOrder: 2,
        active: true,
        loanTypes: [LoanType.Bridge],
    },
    {
        id: PreferredTermType.Thirty,
        name: '30 Year',
        shortName: '30',
        sortOrder: 4,
        active: true,
        loanTypes: [LoanType.BuildRent],
    },
];
